(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishPadelLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }
  function hasKeys(obj) { if (!obj) return false; for (const _ in obj) return true; return false; }
  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const OFFICIAL = resolveOfficial('PADEL');
  const OFFICIAL_RAW = (OFFICIAL && OFFICIAL.official) || {};
  const COURT = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || 20,
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || 10,
    SERVICE_FROM_BASE: Number(OFFICIAL_RAW.serviceLineFromBackWall) || 3.05,
    CENTER_SERVICE_EXTENSION: Number(OFFICIAL_RAW.centerServiceExtension) || 0.2,
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || 0.05
  };
  const HALF_LENGTH = COURT.LENGTH / 2; // 10 m
  const HALF_WIDTH = COURT.WIDTH / 2;   // 5 m
  const SERVICE_LINE_LEFT = COURT.SERVICE_FROM_BASE;              // 3.05 m from back wall
  const SERVICE_LINE_RIGHT = COURT.LENGTH - COURT.SERVICE_FROM_BASE; // 16.95 m
  const CENTER_SERVICE_START = Math.max(0, SERVICE_LINE_LEFT - COURT.CENTER_SERVICE_EXTENSION);
  const CENTER_SERVICE_END = Math.min(COURT.LENGTH, SERVICE_LINE_RIGHT + COURT.CENTER_SERVICE_EXTENSION);

  const SKIP_COLOR = '__SKIP__';

  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function fillRect(ctx, dims, color, x, y, w, h) {
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: dims.hardwood, pattern: dims.pattern, patternTarget: dims.patternTarget, pixelsPerMeter: dims.scaleAvg })
      : color;
    ctx.fillRect(x * dims.scaleX, y * dims.scaleY, w * dims.scaleX, h * dims.scaleY);
  }

  // Use filled rects instead of strokes to keep line thickness visually uniform.
  function fillLineH(ctx, dims, color, x1, x2, yM, widthM, align) {
    const wPx = dims.fixedLineWidthPx || (widthM * dims.scaleAvg);
    const xPx1 = x1 * dims.scaleX;
    const xPx2 = x2 * dims.scaleX;
    const left = Math.min(xPx1, xPx2);
    const width = Math.abs(xPx2 - xPx1);
    const yPx = yM * dims.scaleY;
    const top =
      align === 'inside-top' ? yPx :
      align === 'inside-bottom' ? (yPx - wPx) :
      (yPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, width, wPx);
  }

  function fillLineV(ctx, dims, color, xM, y1, y2, widthM, align) {
    const wPx = dims.fixedLineWidthPx || (widthM * dims.scaleAvg);
    const yPx1 = y1 * dims.scaleY;
    const yPx2 = y2 * dims.scaleY;
    const top = Math.min(yPx1, yPx2);
    const height = Math.abs(yPx2 - yPx1);
    const xPx = xM * dims.scaleX;
    const left =
      align === 'inside-left' ? xPx :
      align === 'inside-right' ? (xPx - wPx) :
      (xPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, wPx, height);
  }

  const PARTS = [
    // Areas
    makePart('padelLeftBackcourt', 10, 'area', 'main', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, 0, SERVICE_LINE_LEFT, COURT.WIDTH);
    }),
    makePart('padelLeftServiceTop', 20, 'area', 'key', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, SERVICE_LINE_LEFT, 0, HALF_LENGTH - SERVICE_LINE_LEFT, HALF_WIDTH);
    }),
    makePart('padelLeftServiceBottom', 30, 'area', 'key', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, SERVICE_LINE_LEFT, HALF_WIDTH, HALF_LENGTH - SERVICE_LINE_LEFT, HALF_WIDTH);
    }),
    makePart('padelRightServiceTop', 40, 'area', 'key', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, HALF_LENGTH, 0, SERVICE_LINE_RIGHT - HALF_LENGTH, HALF_WIDTH);
    }),
    makePart('padelRightServiceBottom', 50, 'area', 'key', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, HALF_LENGTH, HALF_WIDTH, SERVICE_LINE_RIGHT - HALF_LENGTH, HALF_WIDTH);
    }),
    makePart('padelRightBackcourt', 60, 'area', 'main', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, SERVICE_LINE_RIGHT, 0, COURT.LENGTH - SERVICE_LINE_RIGHT, COURT.WIDTH);
    }),

    // Lines
    makePart('padelSidelineTop', 200, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, 0, COURT.LINE, 'inside-top');
    }),
    makePart('padelSidelineBottom', 210, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, COURT.WIDTH, COURT.LINE, 'inside-bottom');
    }),
    makePart('padelBaselineLeft', 220, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, 0, 0, COURT.WIDTH, COURT.LINE, 'inside-left');
    }),
    makePart('padelBaselineRight', 230, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, COURT.LENGTH, 0, COURT.WIDTH, COURT.LINE, 'inside-right');
    }),
    makePart('padelCenterLine', 238, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, CENTER_SERVICE_START, CENTER_SERVICE_END, HALF_WIDTH, COURT.LINE, 'center');
    }),
    makePart('padelServiceLineLeft', 240, 'line', 'lines', 'left', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, SERVICE_LINE_LEFT, 0, COURT.WIDTH, COURT.LINE, 'center');
    }),
    makePart('padelServiceLineRight', 250, 'line', 'lines', 'right', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, SERVICE_LINE_RIGHT, 0, COURT.WIDTH, COURT.LINE, 'center');
    }),
    makePart('padelNetLine', 270, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, HALF_LENGTH, 0, COURT.WIDTH, COURT.LINE, 'center');
    })
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => { acc[part.id] = part; return acc; }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function computeDims(cw, ch, opts) {
    const scaleX = cw / COURT.LENGTH;
    const scaleY = ch / COURT.WIDTH;
    return { scaleX, scaleY, scaleAvg: (scaleX + scaleY) * 0.5, fixedLineWidthPx: Math.max(0, Number(opts && opts.fixedLineWidthPx) || 0), cw, ch };
  }

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) { if (detailColors[id] === SKIP_COLOR) return null; return detailColors[id]; }
    if (fallbackColors && fallbackColors[id]) { if (fallbackColors[id] === SKIP_COLOR) return null; return fallbackColors[id]; }
    if (fallback === 'key') return baseColor.key || baseColor.main;
    if (fallback === 'border') return baseColor.border || baseColor.main;
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#3D8BE0',
    key: '#3BEDCF',
    border: '#FFCD2E',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    const dims = computeDims(cw, ch, opts);
    dims.hardwood = opts && opts.hardwood;
    dims.pattern = opts && opts.pattern;
    dims.patternTargetPrefix = opts && opts.patternTargetPrefix;
    const palette = {
      main: DEFAULT_PALETTE.main,
      key: DEFAULT_PALETTE.key,
      border: DEFAULT_PALETTE.border,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        dims.patternTarget = { id: (dims.patternTargetPrefix || '') + id, role: part.role, fallback: part.fallback };
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        console.warn('[SwishPadelLines] draw error for part', id, err);
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: COURT.WIDTH * 1000, L: COURT.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
